"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchAnyPattern = exports.extractTerms = exports.repeatedTimeunitPattern = void 0;

function repeatedTimeunitPattern(prefix, singleTimeunitPattern) {
  const singleTimeunitPatternNoCapture = singleTimeunitPattern.replace(/\((?!\?)/g, "(?:");
  return `${prefix}${singleTimeunitPatternNoCapture}\\s{0,5}(?:,?\\s{0,5}${singleTimeunitPatternNoCapture}){0,10}`;
}

exports.repeatedTimeunitPattern = repeatedTimeunitPattern;

function extractTerms(dictionary) {
  let keys;

  if (dictionary instanceof Array) {
    keys = [...dictionary];
  } else if (dictionary instanceof Map) {
    keys = Array.from(dictionary.keys());
  } else {
    keys = Object.keys(dictionary);
  }

  return keys;
}

exports.extractTerms = extractTerms;

function matchAnyPattern(dictionary) {
  const joinedTerms = extractTerms(dictionary).sort((a, b) => b.length - a.length).join("|").replace(/\./g, "\\.");
  return `(?:${joinedTerms})`;
}

exports.matchAnyPattern = matchAnyPattern;